<template>
    <component :is="currentIcon" />
</template>

<script setup lang="ts">
    import IconDevMode from './Icons/IconDevMode.vue';
    import IconHome from './Icons/IconHome.vue';
    import IconSettings from './Icons/IconSettings.vue';
    import IconSearch from './Icons/IconSearch.vue';

    const props = defineProps<{
        iconName: string;
    }>();

    const icons: Record<string, ReturnType<typeof defineComponent>> = {
        IconDevMode,
        IconHome,
        IconSettings,
        IconSearch
    };

    const currentIcon = computed(() => {
        return icons[props.iconName];
    });
</script>